import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { data } from "./CarouselData";
import "./Sec1.css";
import { Link } from "react-router-dom";

export default function App() {
  const settings = {
    centerMode: true,
    centerPadding: "0",
    slidesToShow: 3,
    focusOnSelect: true,
    dots: false,
    infinite: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section className="Sec1">
      <div className="innerSec1">
        <Slider {...settings}>
          {data.map((d) => (
            <div className="carousel">
              <div className="textPan">
                <div className="mainHeading" key={d.key}>
                  {d.heading}
                </div>
                <div className="textBtn">
                  <Link to={d.cta} className="cta2">
                    View More
                  </Link>
                </div>
              </div>
              <div className="picPan">
                <img alt="" src={d.img} key={d.key} />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
